import axios from 'axios';
import { baseUrl } from './baseUrl';
import { LOGIN } from '../features/user/userSlice';
import { RESET_PASSWORD_INITIATE, RESET_PASSWORD_SUCCESS } from '../features/auth/authSlice';
import { setAdminType } from '../utils/adminType';
import { setAdminEmail } from '../utils/adminEmail';

// Admin Login
export const adminLogin = async (data, dispatch, navigate, remember, toast) => {
    try {
        const res = await axios.post(`${baseUrl}/admin/auth/admin-login`, data);
        // console.log(res.data);
        if(res.data.success){
            toast.success('Login Successful!');
            if(remember){
                localStorage.setItem('cc-t', res.data.accessToken);
                localStorage.setItem('view', res.data.viewAllTabs);
                setAdminType(res.data.adminType, true);
                setAdminEmail(res.data.email, true);
            }
            else{
                sessionStorage.setItem('cc-t', res.data.accessToken);
                sessionStorage.setItem('view', res.data.viewAllTabs);
                setAdminType(res.data.adminType, false);
                setAdminEmail(res.data.email, false);
            }
            setTimeout(() => {
                dispatch(LOGIN(res.data));
                navigate('/');
            }, 1000);
        }
        if(res.data.error){
            toast.error(res.data.error.message);
        }
    } catch (err) {
        console.log(err);
    }
}

// Admin Forgot Password
export const adminForgotPassword = async (data, dispatch, navigate, toast) => {
    try {
        toast.loading('Sending OTP... Please wait!');
        const res = await axios.post(`${baseUrl}/admin/auth/admin-forgot-password`, data);
        // console.log(res.data);
        if(res.data.success){
            toast.dismiss();
            toast.success(res.data.message);
            dispatch(RESET_PASSWORD_INITIATE(data.email));
            setTimeout(() => {
                navigate('/forgotpasswordotp');
            }, 2000);
        }
        if(res.data.error){
            toast.dismiss();
            toast.error(res.data.error.message);
        }
    } catch (err) {
        toast.dismiss();
        console.log(err);
        toast.error(
            err.response?.data?.error?.message || 
            'An error occurred while sending the OTP. Please try again.'
        );
    }
}

// Admin Forgot Password OTP Send Again
export const sendOtpAgain = async (data, dispatch, toast) => {
    try {
        toast.loading('Sending OTP... Please wait!');
        const res = await axios.post(`${baseUrl}/admin/auth/admin-forgot-password`, data);
        // console.log(res.data);
        if(res.data.success){
            toast.dismiss();
            toast.success(res.data.message);
            dispatch(RESET_PASSWORD_INITIATE(data.email));
        }
        if(res.data.error){
            toast.dismiss();
            toast.error(res.data.error.message);
        }
    } catch (err) {
        toast.dismiss();
        console.log(err);
        toast.error(
            err.response?.data?.error?.message || 
            'An error occurred while sending the OTP. Please try again.'
        );
    }
}

// Admin Forgot Password OTP
export const adminForgotPasswordOtp = async (data, dispatch, navigate) => {
    try {
        const res = await axios.post(`${baseUrl}/admin/auth/admin-forgot-password`, data);
        // console.log(res.data);
        if(res.data.success){
            alert(res.data.message);
            dispatch(RESET_PASSWORD_INITIATE());
            navigate('/forgotpasswordotp');
        }
        if(res.data.error){
            alert(res.data.error.message);
        }
    } catch (err) {
        console.log(err);
    }
}

// Admin Change Password (logged-in admin rotates their own password)
export const adminChangePassword = async (data, dispatch, navigate, toast) => {
    try {
        const token = localStorage.getItem('cc-t') || sessionStorage.getItem('cc-t');
        const res = await axios.post(
            `${baseUrl}/admin/auth/admin-change-password`,
            data,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        if (res.data && res.data.success) {
            toast.success(res.data.message || 'Password changed successfully.');
            setTimeout(() => navigate('/'), 1500);
        } else if (res.data && res.data.error) {
            toast.error(res.data.error.message || 'Could not change password.');
        }
    } catch (err) {
        const msg =
            err.response?.data?.error?.message ||
            err.response?.data?.message ||
            'Could not change password. Please try again.';
        toast.error(msg);
        console.log('changePassword error:', err);
    }
};

// Admin Reset Password
export const adminResetPassword = async (data, dispatch, navigate, toast) => {
    try {
        const res = await axios.post(`${baseUrl}/admin/auth/admin-reset-password`, data);
        // console.log(res.data);
        if(res.data.success){
            toast.success(res.data.message);
            setTimeout(() => {
                dispatch(RESET_PASSWORD_SUCCESS());
                navigate('/login');
            }, 2000);
        }
        if(res.data.error){
            toast.error(res.data.error.message);
        }
    } catch (err) {
        console.log(err);
        toast.error('Something went wrong!');
    }
}